export default {
  detail: [
    {
      id: '1',
      content: '工业和信息化部人才交流中心是中央机构编制委员会办公室批准成立、国家事业单位登记管理局登记、工业和信息化部直属的二类事业单位，是工业和信息化部从事人才培养、人才交流、国际合作、智力引进、人力资源服务、人才领域研究咨询等方面工作的机构。'
    },
    {
      id: '2',
      content: '中心前身为创立于1985年1月的电子工业部人才交流咨询服务中心，1 992年10月成为独立事业法人单位，历经了“ 机械电子工业部人才交流中心“、“电子工业部人才交流中心”、”信息 产业部电子人才交流中心“多个发展阶段，2008年12月正式更名为“工业和信息化部人才交流中心”。'
    },
    {
      id: '3',
      content: '多年来，中心作为工业和信息化部人才工作的实施单位之一，围绕“服务人才”宗旨，以政府服务、行 业与企业服务、院校合作为主要业务方向，锐意进取，开拓前行，取得了长足发展。中心是中国人才交流协 会国家机关人才交流机构分会会长单位，承载着国家专业技术人才继续教育基地、国家中小企业公共服务示范 平台、工业和信息化人才公共服务平台、工业和信息化部专业技术人才知识更新工程协调小组办公室、工业和 信息化部企业经营管理人才素质提升工程协调小组办公室、工业和信息化部引进国外智力工作办公室等多重职能。'
    },
    {
      id: '4',
      content: '在多年的人才工作中，中心积累了丰富的资源，与北京大学、清华大学、中国科学院大学、麻省理工大学、 斯坦福大学、比利时微电子研究中心、德国氟兰霍夫研究院等2000余家著名大学、科研机构建立了友好合作 关系，业务拓展至美国、英国、加拿大、澳大利亚、德国、法国、日本、韩国、瑞典、新加坡等全球二十多 个主要发达国家，服务企业超过10000家，形成了国际人才交流、全国中小企业领军人才培养、“蓝桥杯” 软件和信息技术大赛、“蓝桥杯”软件学院、全国工业和信息化专业技术人才知识更新工程高级研修班、 中高端人才招聘等在国内具有影响力的核心业务体系，组织各类出国考察培训团组1000多个，向国外派遣 各种层次的技术和管理交流人员10000余人，引进外国技术和管理专家数千人次，在国内组织了上百万人次 参加的多种专业培训，为不同层次的管理、技术岗位培养了大批人才，向科研院所、企事业单位、教育文化 机构推荐了大量高层次人才，为推进国民经济信息化建设，走中国特色新型工业化道路做出了积极贡献，中 心也获评为中央国家机关和首都精神文明“双文明”单位、北京市人力资源诚信服务示范单位。'
    },
    {
      id: '5',
      content: '未来，中心将严格遵照国家部署、工业和信息化部要求，紧跟新工业革命快速推进步伐，以产业需求为导 向培养专业人才，围绕人才发展推进国家工业化与信息化的深度融合，努力将自身打造成为工业和信息化领 域最权威、最专业、最具实力的国际化人才机构，为我国工业和信息化事业贡献更大的力量！'
    }
  ],
  type: [
    {
      id: '1',
      code: '001',
      name: '党委简介'
    },
    {
      id: '2',
      code: '002',
      name: '联系我们'
    },
    {
      id: '3',
      code: '003',
      name: '地理位置'
    },
    {
      id: '4',
      code: '004',
      name: '作风建设监督'
    }
  ],
  tableData: [
    {
      id: '1',
      firstLine: '处室/事项名称',
      secondLine: '咨询电话'
    },
    {
      id: '2',
      firstLine: '综 合 处',
      secondLine: '68207839'
    },
    {
      id: '3',
      firstLine: '财 务 处',
      secondLine: '68207841'
    },
    {
      id: '4',
      firstLine: '国际合作处',
      secondLine: '68207446、68207416'
    },
    {
      id: '5',
      firstLine: '人事代理处',
      secondLine: '68207466、68207463'
    },
    {
      id: '6',
      firstLine: '人才开发处',
      secondLine: '68207889'
    },
    {
      id: '7',
      firstLine: '教育培训处',
      secondLine: '68208722'
    }
  ]
}
